/**
 * @file PaddleHub 首页教学卡片
 * @author FengGuang(fengguang01@baidu.com)
 */
import React from 'react';
import classNames from 'classnames';

import { ITeaching } from '../../types';
import A from '../../../../components/a/A';

const TeachingCards: React.FC<ITeaching> = props => {
    const { list, linkMore } = props;

    return (
        <div className="paddle-hub-teaching-card-wrap">
            <div className="paddle-hub-teaching-card-group clear-both">
                {list.map(item => (
                    <A
                        key={item.title}
                        className="paddle-hub-teaching-card"
                        href={item.links.href}
                    >
                        <div
                            className={classNames(
                                'paddle-hub-teaching-card-head',
                                {
                                    'paddle-hub-teaching-card-head-no-info': !item.prev && !item.fork && !item.star
                                }
                            )}
                        >
                            <div className="paddle-hub-teaching-card-title">
                                {item.title}
                            </div>
                            <div className="paddle-hub-teaching-card-info">
                                {!!item.prev
                                    && (
                                        <span className="paddle-hub-teaching-card-info-item">
                                            <i className="paddle-hub-teaching-card-info-icon paddle-hub-teaching-card-info-icon-prev" />
                                            <span>{item.prev}</span>
                                        </span>
                                    )
                                }
                                {!!item.fork
                                    && (
                                        <span className="paddle-hub-teaching-card-info-item">
                                            <i className="paddle-hub-teaching-card-info-icon paddle-hub-teaching-card-info-icon-fork" />
                                            <span>{item.fork}</span>
                                        </span>
                                    )
                                }
                                {!!item.star
                                    && (
                                        <span className="paddle-hub-teaching-card-info-item">
                                            <i className="paddle-hub-teaching-card-info-icon paddle-hub-teaching-card-info-icon-star" />
                                            <span>{item.star}</span>
                                        </span>
                                    )
                                }
                            </div>
                        </div>
                        <div className="paddle-hub-teaching-card-body">
                            <div className="paddle-hub-teaching-card-context">
                                {item.content}
                            </div>
                            <div className="paddle-hub-teaching-card-tags">
                                <span>
                                    {item.links.label}
                                </span>
                            </div>
                        </div>
                    </A>
                ))}
            </div>
            {!!(linkMore && linkMore.label)
                && (
                    <div className="paddle-hub-teaching-card-link">
                        <a href={linkMore.href}>
                            {linkMore.label} <i className="paddle-hub-teaching-card-right-icon" />
                        </a>
                    </div>
                )}
        </div>
    );
};

export default TeachingCards;
